/** @format */

import React from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import ArticleLayout from 'components/ArticleLayout';
import Container from 'react-bootstrap/Container';
import { LeadsSectionBody, LeadSources } from 'components/LeadsGenerator';

import './styles.scss';

export default function Fm30ArticlePage(props) {
  const text = props.t('lang_registration:fm30_article');
  const { isMobileView } = props;

  return (
    <>
      <div className='main-container fm30-article-page-container'>
        <Header {...props} />
        <div className='inner-container'>
          <Container>
            {/* Page content here */}
            <ArticleLayout
              text={text}
              isMobileView={isMobileView}
              banner={'images/fm30-main.png'}
              subIcon={'images/fm30-middle.png'}
              subIcon1={'images/fm30-last.png'}
              showFocusButtons={true}>
              <LeadsSectionBody
                metadata={{
                  source: LeadSources.FM_BUILD_PROPERTY
                }}
                showPropertyTypes={true}
                showUrgency={true}
                showTextInputs={true}
                showLeadTypes={true}
                showSquareMeterInput={true}
                showNumberOfRoomsInput={true}
                showAddressInput={true}
                showBrokerStatusSelector={true}
                {...props}
              />
            </ArticleLayout>
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
